import { ErrorPageView } from 'components/modules/Error';
import React, { FC } from 'react';

export const ErrorPage: FC = () => {
  return <ErrorPageView errorCode={'NOT_FOUND'} />;
};
